export const compareText = (a, b, ...texts) =>
  +(a === texts[texts.length - 1]) - +(b === texts[texts.length - 1]) ||
  (texts.length > 0 ? compareText(a, b, ...texts.slice(0, -1)) : 0);

export const separateCamelCase = (word) => {
  let currentWord = '';
  const sections = [];
  for (let i = 0; i < word.length; i++) {
    const letter = word[i];
    if (letter.toUpperCase() === letter) {
      sections.push(currentWord);
      currentWord = '';
    }
    currentWord += currentWord.length === 0 ? letter.toUpperCase() : letter;
  }
  sections.push(currentWord);
  return sections;
};

export const ucFirst = (text) => {
  return text.slice(0, 1).toUpperCase() + text.slice(1);
};
